module.exports = __webpack_public_path__ + "60439690cab3c929d55f69c0edfbf528.png";